import { render } from "./ImageResizer.vue?vue&type=template&id=630ad2ce&scoped=true&ts=true"
import script from "./ImageResizer.vue?vue&type=script&lang=ts"
export * from "./ImageResizer.vue?vue&type=script&lang=ts"

import "./ImageResizer.vue?vue&type=style&index=0&id=630ad2ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630ad2ce"]])

export default __exports__